class JoinProgramForm {
  constructor() {
    this.modal = document.getElementById('join-program-modal');
    this.overlay = document.getElementById('join-program-modal-overlay');
    this.triggerSelector = '[href="#JoinProgram"],[data-join-program-trigger]';
    this.closeSelector = '[data-join-program-close]';

    if (!this.modal || !this.overlay) return;

    this.init();
  }

  init() {
    document.addEventListener('click', (e) => {
      // Open
      const trigger = e.target.closest(this.triggerSelector);
      if (trigger) {
        e.preventDefault();
        this.open();
      }

      // Close
      const closeBtn = e.target.closest(this.closeSelector);
      if (closeBtn || e.target === this.overlay) {
        this.close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  open() {
    this.modal.style.display = 'flex';
    this.overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.modal.style.display = 'none';
    this.overlay.style.display = 'none';
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new JoinProgramForm();
});
